export default __webpack_public_path__ + "images/swap_33eb94.svg";